import {useCallback} from 'react';
import {useGuestCardStore} from '../useGuestCardStore';
import type {Guest} from '@chekin/core';

export const useGuestCard = () => {
  const guestCardData = useGuestCardStore(state => state.guestCardData);

  const saveGuestCardData = useCallback((guest: Guest) => {
    const guestName = `${guest.name || ''} ${guest.surname || ''}`.trim();

    if (guestName) {
      useGuestCardStore.getState().setGuestCardData({
        guest_name: guestName,
        room_number: '101', // Hardcodeado por ahora
      });
      return true;
    } else {
      useGuestCardStore.getState().clearGuestCardData();
      return false;
    }
  }, []);

  const clearGuestCard = useCallback(() => {
    useGuestCardStore.getState().clearGuestCardData();
  }, []);

  const setRoomNumber = useCallback((roomNumber: string) => {
    useGuestCardStore.getState().setRoomNumber(roomNumber);
  }, []);

  const setGuestName = useCallback((guestName: string) => {
    useGuestCardStore.getState().setGuestName(guestName);
  }, []);

  return {
    guestCardData,
    saveGuestCardData,
    clearGuestCard,
    setRoomNumber,
    setGuestName,
  };
};
